export const PRO_TYPE_CHOICES = [
  { id: "PSW", name: "PSW" },
  { id: "COMPANION", name: "Companion" },
];
